import { post } from 'utils/fetch/fetchHelper'

export const logError = (error: Error) =>
  post('/log-error', { error: error.message })
